// Temporary frozen taco directory data used until Supabase frozen_tacos is populated.
export const frozenTacosFallback = [
  {
    Brand: 'Del Real Foods',
    Type: 'Birria',
    Price: '$$',
    Rating: 7.5,
    Notes: 'Shredded beef with heat-and-serve tortillas; pairs well with homemade consomme.',
  },
  {
    Brand: 'Siete Grain Free',
    Type: 'Veggie',
    Price: '$$',
    Rating: 8.0,
    Notes: 'Gluten-free shells with poblano and black bean filling.',
  },
  {
    Brand: 'Trader Joe\'s',
    Type: 'Al Pastor',
    Price: '$',
    Rating: 6.5,
    Notes: 'Great for a quick weeknight option—amp it up with fresh pineapple.',
  },
]
